import React, { useEffect, useRef, useState } from "react";

const RecipesSlider = ({
  recipesVideoData,
  ytThumb,
  handleVideoPreview,
  activeIndex,
}) => {
  const sliderRef = useRef(null);
  const prevBtnRef = useRef(null);
  const nextBtnRef = useRef(null);

  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(true);

  // Arrow visibility updater
  const updateArrows = () => {
    if (!sliderRef.current) return;
    const scrollLeft = sliderRef.current.scrollLeft;
    const maxScroll =
      sliderRef.current.scrollWidth - sliderRef.current.offsetWidth;
    setShowPrev(scrollLeft > 0);
    setShowNext(scrollLeft < maxScroll - 1);
  };

  const scrollByCard = (direction) => {
    if (!sliderRef.current) return;
    const cardWidth =
      sliderRef.current.querySelector(".recipes-thumb-img-wrapper")
        ?.offsetWidth || 0;
    sliderRef.current.scrollBy({
      left: direction * cardWidth,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const sliderEl = sliderRef.current;
    if (!sliderEl) return;

    // Initial check
    updateArrows();

    // Scroll listener
    sliderEl.addEventListener("scroll", updateArrows);

    // Cleanup on unmount
    return () => {
      sliderEl.removeEventListener("scroll", updateArrows);
    };
  }, []);

  return (
    <>
      <div className="recipes-thumb-wrapper" ref={sliderRef}>
        {recipesVideoData.length > 0 &&
          recipesVideoData.map((item, ind) => (
            <div
              className={`recipes-thumb-img-wrapper ${
                ind === activeIndex ? "active" : ""
              }`}
              onClick={() => handleVideoPreview(item.youtubeLink, ind)}
              key={ind}
            >
              <img src={ytThumb} className="recipes-yt-thumb" alt="" />
              <img
                src={`https://i.ytimg.com/vi/${item.youtubeLink}/maxresdefault.jpg`}
                className="recipes-main-thumb"
                alt=""
              />
            </div>
          ))}
      </div>

      {showPrev && (
        <div
          className="recipe-video-prev"
          ref={prevBtnRef}
          onClick={() => scrollByCard(-1)}
        ></div>
      )}
      {showNext && (
        <div
          className="recipe-video-next"
          ref={nextBtnRef}
          onClick={() => scrollByCard(1)}
        ></div>
      )}
    </>
  );
};

export default RecipesSlider;
